import { parseAsString, useQueryState } from "nuqs";
// import { countriesData } from "../data/conversions.data";

export const useScales = () => {
  const [countryId, setCountryId] = useQueryState("countryId", parseAsString);

  const [gradingScaleId, setGradingScaleId] = useQueryState(
    "gradingScaleId",
    parseAsString
  );

  return {
    setCountryId,
    setGradingScaleId,
    countryId,
    gradingScaleId,
  };
};
